import { fetchDatalakeFile } from '@/services/http/datalake';

const downloadTextFileFromDatalake = async (fileName: string, groupName: string) => {
  return fetchDatalakeFile({ fileName, groupName }, 'text');
};

export default downloadTextFileFromDatalake;
